import { useQuery } from "@tanstack/react-query";
import { SocialPlatformsAPI } from "../api";

const fetchData = () => {
    return SocialPlatformsAPI.get();
};

export const useFetchSocialPlatforms = () => {
    return useQuery({
        queryKey: ["social-platform"],
        queryFn: fetchData,
        keepPreviousData: true, // smooth switching
    });
};
